import { Box } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import * as styles from './index.css';

interface Props {
  text: string;
  isHeading: boolean;
}

export const HintText: FunctionComponent<Props> = ({
  text,
  isHeading,
}: Props) => (
  <Box component="span" className={isHeading ? styles.heading : styles.hint}>
    {text}
  </Box>
);
